import { render } from "./deelnemersDialog.vue?vue&type=template&id=20a102ca"
import script from "./deelnemersDialog.vue?vue&type=script&lang=js"
export * from "./deelnemersDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__